var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "50%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "py-0 mt-4" },
            [
              _c("v-autocomplete", {
                attrs: {
                  dense: "",
                  items: _vm.folders,
                  outlined: "",
                  "item-text": "name",
                  "item-value": "fid",
                  "return-object": "",
                  "small-chips": "",
                  "deletable-chips": "",
                  label: "Target Folder",
                },
                model: {
                  value: _vm.finalFolder,
                  callback: function ($$v) {
                    _vm.finalFolder = $$v
                  },
                  expression: "finalFolder",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "py-0 mb-6" },
            [
              _c("v-progress-linear", {
                attrs: {
                  color: "blue",
                  height: "20",
                  value: _vm.uploadProgress,
                  striped: "",
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "mt-n5" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { disabled: !_vm.btnEnabled, color: "primary" },
                  on: { click: _vm.onPressMove },
                },
                [_vm._v("UPLOAD ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }